import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_CONTENT_HEIGHT } from '../../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 'unset',
    ...theme.mixins.appClickableContainer,
    ...theme.mixins.appContainersSpacing,
    cursor: 'default',
    '&:hover': {
      borderColor: 'transparent',
    },
  },
  leftBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 0,
    maxWidth: 'calc(100% - 80px)',
  },
  titleSkeleton: {
    width: '100%',
    maxWidth: '70%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  subtitleSkeleton: {
    width: '100%',
    maxWidth: '50%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  iconsBlock: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    flexShrink: 0,
  },
  iconSkeleton: {
    flexShrink: 0,
  },
}));
